// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QQbJ","right":"styles_right__2nfQ0"};